<template>
    <div class="contaier-guide" @touchmove.prevent @click="guideClick">
        <div :class="['pop-card', screenHeight >= 812 ? 'maxNav' : 'minNav']">
            <div class="score-area">
                <div class="grade-ic">
                    <span class="curr-level">{{ currLevel }}</span>
                </div>
                <div class="score-tit">活力值</div>
                <div class="arrow-right"></div>
            </div>
            <div class="score-value">
                {{ totalScore }}
            </div>
            <div class="curr-grate">
                {{ currLevel }}
            </div>

            <div class="qpItem qp1" v-if="bubblesList && bubblesList.length > 0">
                <div class="qipao-bg">
                    <div class="qipao-score">{{ bubblesList[0].score }}</div>
                </div>
                <div class="qipao-title">{{ bubblesList[0].title }}</div>
            </div>

            <div class="qpItem qp2" v-if="bubblesList && bubblesList.length > 1">
                <div class="qipao-bg">
                    <div class="qipao-score">{{ bubblesList[1].score }}</div>
                </div>
                <div class="qipao-title">{{ bubblesList[1].title }}</div>
            </div>

            <div class="qpItem qp3" v-if="bubblesList && bubblesList.length > 2">
                <div class="qipao-bg">
                    <div class="qipao-score">{{ bubblesList[2].score }}</div>
                </div>
                <div class="qipao-title">{{ bubblesList[2].title }}</div>
            </div>

            <div class="qpItem qp4" v-if="bubblesList && bubblesList.length > 3">
                <div class="qipao-bg">
                    <div class="qipao-score">{{ bubblesList[3].score }}</div>
                </div>
                <div class="qipao-title">{{ bubblesList[3].title }}</div>
            </div>

            <div class="qpItem qp5" v-if="bubblesList && bubblesList.length > 4">
                <div class="qipao-bg">
                    <div class="qipao-score">{{ bubblesList[4].score }}</div>
                </div>
                <div class="qipao-title">{{ bubblesList[4].title }}</div>
            </div>
        </div>
        <div class="bottom-ic" v-if="bubblesList">
            已经完成{{ bubblesList.length }}个任务，奖励{{ awardScore }}活力值
        </div>
        <div class="bottom-butn" @click="guideClick">我知道了</div>
    </div>
</template>

<script>
export default {
    props: ['bubbleScoreData'],
    data() {
        return {
            bubblesList: [], // 可领气泡
            currLevel: 1,
            totalScore: 0,
            awardScore: 0,
            screenHeight: screen.height
        };
    },
    watch: {
        bubbleScoreData: {
            deep: true,
            immediate: true,
            handler: function(newV) {
                if (newV && newV.length > 0) {
                    console.log(newV, '1111-data');
                    this.bubblesList = [];
                    this.awardScore = 0;
                    newV.forEach(items => {
                        if (items.bubbleType === 0) {
                            this.bubblesList.push(items);
                            this.awardScore = this.awardScore + items.score;
                        }
                    });
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_event_id: 'h5_ACT_taskfinish_scmc',
                        tgt_name: 'h5-ACT-成长权益-气泡任务栏-首次任务完成蒙层',
                        param: this.bubblesList.length,
                        param1: this.awardScore
                    });
                }
            }
        }
    },
    created() {
        this.getScoreProgressV2();
    },
    methods: {
        guideClick() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_taskfinish_scmc',
                tgt_name: 'h5-ACT-成长权益-气泡任务栏-首次任务完成蒙层',
                param: this.bubblesList.length,
                param1: this.awardScore
            });
            this.$emit('homecardGuideClose');
        },
        async getScoreProgressV2() {
            const { Result, Content } = await this.$http.getScoreProgressV2({});
            if (Result === 200) {
                this.currLevel = Content.currentLevelIndex;
                this.totalScore = Content.totalScore;
            }
        }
    }
};
</script>

<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
@assertV4: '../../../../assets/growth4.0/';
.contaier-guide {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 100;
    .maxNav {
        margin: 109px 16px 0;
    }
    .minNav {
        margin: 99px 16px 0;
    }
    .pop-card {
        padding-left: 20px;
        position: absolute;
        width: 343px;
        height: 170px;
        background-image: url('@{assertV4}garde-card-ic@2x.png');
        background-size: 100% 100%;
        .score-area {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 34px;
            margin-bottom: 10px;
            .grade-ic {
                width: 27px;
                height: 21px;
                background-size: 100% 100%;
                background-image: url('@{assertV4}level-bg-ic@2x.png');
                padding-top: 1px;
                .curr-level {
                    margin-left: 17px;
                    color: #f88800;
                    font-size: 8px;
                    font-weight: bold;
                }
            }
            .score-tit {
                margin-left: 4px;
                color: #fff5e4;
                font-size: 13px;
            }
            .arrow-right {
                margin-left: 3px;
                width: 6px;
                height: 9px;
                background-image: url('@{assertV4}arrow-right@2x.png');
                background-size: 100% 100%;
            }
        }
        .score-value {
            color: #ffffff;
            font-size: 34px;
            font-weight: bolder;
            font-family: uni_sans_regular;
        }
        .curr-grate {
            position: absolute;
            margin-left: 284px;
            margin-top: 28px;
            color: #fff;
            font-size: 42px;
            font-weight: bold;
            opacity: 0.1;
        }
        .qp1 {
            margin-left: 100px;
            margin-top: -46px;
        }
        .qp2 {
            margin-left: 180px;
            margin-top: -58px;
        }
        .qp3 {
            margin-left: 154px;
            margin-top: 10px;
        }
        .qp4 {
            margin-left: 236px;
            margin-top: -5px;
        }
        .qp5 {
            margin-left: 246px;
            margin-top: -72px;
        }
        .qpItem {
            width: 86px;
            height: 60px;
            position: absolute;
            .qipao-bg {
                margin-left: 18px;
                width: 34px;
                height: 34px;
                background-image: url('@{asserts}/qipao-high@2x.png');
                background-size: 100% 100%;
                .qipao-score {
                    text-align: center;
                    line-height: 34px;
                    font-weight: bolder;
                    color: #fff;
                    font-size: 10px;
                }
            }
            .qipao-title {
                margin-top: 5px;
                margin-left: -4px;
                color: #fff;
                font-size: 10px;
                text-align: center;
                line-height: 12px;
                width: 92%;
                height: 36px;
                text-align: center;
            }
        }
    }
    .bottom-ic {
        margin-left: 49px;
        margin-top: 276px;
        width: 242px;
        height: 73px;
        background-image: url('@{assertV4}qpguide-bottom@2x.png');
        background-size: 100% 100%;
        color: #fff;
        font-size: 14px;
        line-height: 108px;
        text-align: center;
    }
    .bottom-butn {
        margin: 200px 131px 80px;
        width: 114px;
        height: 36px;
        border-radius: 18px;
        border: 1px solid rgba(255, 255, 255, 0.6);
        color: #fff;
        font-size: 13px;
        line-height: 36px;
        text-align: center;
    }
}
</style>